// extracted by mini-css-extract-plugin
module.exports = {"container":"styles__container___1qERG","steps":"styles__steps___2_jAi","title":"styles__title___spKtK","back-icon":"styles__back-icon___2tilx"};